import { Injectable } from '@angular/core';
import { Session } from '@services/session';

@Injectable()
export class BeaconSupportAccessGuard {

  constructor(private session: Session) { }

  public canLoad(): boolean {
    return this.session.hasCompanyBeaconFeatureEnabled();
  }
}
